import { FE_BATCH_10_TOP_NAV_SIGNUP_CTA_250522 } from "@faire/retailer-settings/FE_BATCH_10_TOP_NAV_SIGNUP_CTA_250522";
import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";

export const useSettingBatch10TopNavSignupCTA = () => {
  return useSetting(FE_BATCH_10_TOP_NAV_SIGNUP_CTA_250522);
};
export const useAssignSettingBatch10TopNavSignupCTA = () =>
  useAssignSetting(FE_BATCH_10_TOP_NAV_SIGNUP_CTA_250522);
